import React          from 'react';
import ReactDom       from 'react-dom';
import Moment         from 'moment';

import Utils          from 'utils';
import Const          from 'fw_const';

// -------------------------------------------------------

const S3_BUCKET  ='casting-admin';
const S3_URL     = 'https://casting-admin.s3.ap-northeast-1.amazonaws.com/';
const REGION     ='ap-northeast-1';
const SIZE_LIMIT = (1024 * 1024 * 5000);
// -------------------------------------------------------

class S3Upload extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      upload_file: [],
      completes : [],
      file_count : 0,
    }
  }
  // -------------------------------------------------------
  
  componentWillMount(){
    this.props.setEvent('file_upload', this.fileUpload.bind(this));
    this.props.setEvent('file_upload_max_check', this.fileUploadMaxCheck.bind(this));
    this.props.setEvent('get_media', this.getMedia.bind(this));
  }
  // -------------------------------------------------------
  
  /*
   * ファイルアップロード
   */
  fileUpload(e, dir, after_params) {
    if( dir == undefined ) dir = '';
    
    // ファイルアップロード
    let files = e.target.files;
    if( files.length > 0 ) {
      for( let i in files ){
        this.actionUpload.bind(this)(files[i], dir, after_params);
      }
    }
    
    let file_count = (this.state.file_count + files.length);
    this.setState({ file_count: file_count });
  }
  // -------------------------------------------------------
  
  /*
   * ファイルアップロード
   */
  fileUploadMaxCheck(e, dir, cnt, max_count) {
    let count = (cnt + e.target.files.length);
    if( count > max_count ){
      alert('登録が可能なファイルの数は、'+ max_count +'個までです');
    }
    
    this.fileUpload.bind(this)(e, dir);
  }
  // -------------------------------------------------------
  
  /*
   * モーダルクローズイベント
   */
  actionUpload(file, dir, after_params) {
      console.log(file);
    if( file.size == undefined ) return;
    
    if( file.size > SIZE_LIMIT ){
      alert('ファイルサイズが大きいためアップロードできませんでした。');
      return;
    }
    
    // パラメータ設定
    const params = {
      ACL    : 'public-read',
      Body   : file,
      Bucket : S3_BUCKET,
      Key    : (dir + Utils.md5(Moment().unix() +'_'+ Math.random() )),
    };
    
    // ファイル種別判定（MIMEタイプが取れない形式は拡張子で判定）
    let type     = (file.type || '').toLowerCase();
    let is_video = (type.indexOf('video/') === 0 || (type === '' && Utils.isVideo(file.name)));
    let is_image = (type.indexOf('image/') === 0);

    if( is_image == false && is_video == false ){
      alert('画像/動画以外のデータが選択されました');
      return;
    }

    // mov 等は Chrome / Firefox で video/quicktime のままだと再生されないため video/mp4 として保存する
    if( is_video == true && (type === '' || type === 'video/quicktime') ) params.ContentType = 'video/mp4';

    params.Key += ( is_video == true ) ? '.mp4' : '.png';
    this.awsUpload.bind(this)(params, after_params);
  }
  // -------------------------------------------------------
  
  /*
   * モーダルクローズイベント
   */
  awsUpload(params, after_params) {
    // presigned URL をサーバーから取得してブラウザから直接 S3 へ PUT
    Utils.request('/api/dashboard/s3', { code: this.props.code, key: params.Key },
      (res) => {
        const { uploadUrl } = res.body.data;

        const xhr = new XMLHttpRequest();
        xhr.open('PUT', uploadUrl);
        xhr.setRequestHeader('Content-Type', params.ContentType || params.Body.type || 'application/octet-stream');

        xhr.upload.onprogress = (evt) => {
          if (!evt.lengthComputable) return;
          let upload_file = this.state.upload_file;
          upload_file[params.Key] = {
            progress    : Math.round((evt.loaded / evt.total) * 100),
            after_params: after_params,
          };
          this.setState({ upload_file: upload_file });
          if (this.props.actionProgress != undefined) this.props.actionProgress.bind(this)();
        };

        xhr.onload = () => {
          if (xhr.status !== 200 && xhr.status !== 204) {
            console.log('S3 upload error', xhr.status);
          }
        };

        xhr.onerror = () => console.log('S3 upload network error');
        xhr.send(params.Body);
      },
      () => {
        alert('エラーが発生しました');
        this.setState({ loading: false });
      }
    );
  }
  // -------------------------------------------------------
  
  /*
   * モーダルクローズイベント
   */
  getMedia(params) {
    let completes = this.state.completes;
    
    // アップロードメディアの配列化
    let upload_file_ary = [];
    for( let i in this.state.upload_file ){
      let upd = this.state.upload_file[i];
      
      let progress = upd.progress;
      let is_complete = (progress >= 100 && completes.indexOf(i) == -1);
      if( is_complete == true ){
        completes.push(i);
        this.setState({ completes: completes });
      }
      
      upload_file_ary.push({
        id           : i,
        url          : (S3_URL+ i),
        progress     : progress,
        after_params : upd.after_params,
        is_complete  : is_complete,
        file_count   : this.state.file_count,
      });
    }
    return upload_file_ary;
    
  }
  // -------------------------------------------------------
  
  /*
   * 出力処理
   */
  render() {
    return null;
  }
}
// -------------------------------------------------------

export default S3Upload;
